<template>
    <div class="dashboard-reporting-history-view">
        <div class="dashboard-reporting-history-view__filters">
            <BaseInput
                :debounce="400"
                :placeholder="$t('searchPlaceholder')"
                block
                trim
                @input="nameSearchQuery = $event"
            >
                <template #icon>
                    <SearchIcon width="16" height="16" />
                </template>
            </BaseInput>

            <BaseButton
                v-if="isReportingDisabled"
                v-tooltip="{
                    content: $t('reportingDisabled'),
                    trigger: 'hover',
                }"
                block
                disabled
            >
                {{ $t('create') }}
            </BaseButton>

            <BaseButton v-else block @click="openCreateModal">
                <template #icon>
                    <AddIcon width="16" height="16" />
                </template>

                {{ $t('create') }}
            </BaseButton>
        </div>

        <div class="dashboard-reporting-history-view__content">
            <ReportingHistoryTable
                ref="reportsTable"
                :filter-name="nameSearchQuery"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import AddIcon from '../icons/AddIcon'
import BaseButton from '../redesigned/BaseButton'
import BaseInput from '../redesigned/BaseInput'
import DashboardReportingModal from './DashboardReportingModal'
import ReportingHistoryTable from '../ReportingHistoryTable'
import SearchIcon from '../icons/SearchIcon'

export default {
    name: 'DashboardReportingHistoryView',
    components: {
        AddIcon,
        BaseButton,
        BaseInput,
        ReportingHistoryTable,
        SearchIcon,
    },
    data() {
        return {
            nameSearchQuery: '',
        }
    },
    computed: {
        ...mapState('tracker', ['trackers']),
        ...mapState('maintenance', ['maintenancePolicies']),
        isReportingDisabled() {
            return ['true', '1'].includes(
                process.env.VUE_APP_REPORTING_DISABLED?.toLocaleLowerCase()
            )
        },
    },
    methods: {
        openCreateModal() {
            if (this.isReportingDisabled) {
                return
            }
            this.$modal.show(
                DashboardReportingModal,
                {
                    onSubmit: () =>
                        this.$refs.reportsTable?.fetchReportingHistory(),
                },
                { width: 400, height: '75%' }
            )
        },
    },
}
</script>

<i18n>
{
    "en": {
        "create": "Create a new report",
        "searchPlaceholder": "Name",
        "reportingDisabled": "Reporting is temporarily disabled"
    },
    "de": {
        "create": "Einen neuen Report erstellen",
        "searchPlaceholder": "Name",
        "reportingDisabled": "Reports sind vorübergehend deaktiviert"
    },
    "fr": {
        "create": "Créer un nouveau rapport",
        "searchPlaceholder": "Nom",
        "reportingDisabled": "les rapports sont temporairement désactivés"
    },
    "it": {
        "create": "Creare un nuovo rapporto",
        "searchPlaceholder": "Nome",
        "reportingDisabled": "I rapporti sono temporaneamente disabilitati"
    }
}
</i18n>

<style lang="scss" scoped>
.dashboard-reporting-history-view {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &__filters {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 1.5rem 1rem 0.5rem 2rem;
        background-color: $color-gray-lighter-new;
        border-bottom: $style-border;

        & > * {
            margin-right: 1rem;
            margin-bottom: 1rem;
        }

        .base-input,
        .multiselect {
            max-width: 200px;
        }
    }

    &__content {
        display: flex;
        overflow-y: auto;

        & > * {
            width: 100%;
            overflow-x: auto;
        }
    }

    @include respond-to('for-small-mobile-only') {
        &__filters {
            padding: 1rem 1rem 0;

            & > * {
                &:not(.base-button) {
                    margin-right: 0;
                    max-width: 100%;
                    width: 100%;
                }
            }
        }
    }
}
</style>
